import {
  React,
  useState,
  useEffect,
  useCallback,
} from "react";
import Page from "../../finwell/pages/Page";
import Loader from "../../components/Loader/Loader";
import EventsCalendar from "../../components/Calendar/EventsCalendar";

const EventsCalendarPage = (event) => {
  const [isLoading, setIsLoading] = useState(true);
  const [selectedSessionFromHome, setSelectedSessionFromHome] = useState({});
  const [selectedSessionPos, setSelectedSessionPos] = useState(0)

  return (
    <>
      {/* <Loader start={isLoading} /> */}
      <Page>
        <EventsCalendar isHome={false} isLearn={false}
        marketingDateRange={null}
        setSelectedSessionFromHome={setSelectedSessionFromHome}
        selectedSessionPos={selectedSessionPos}
        setSelectedSessionPos={setSelectedSessionPos}
        isMobile={false}
        isEvents={true}
        />

      </Page>
    </>
  );
};

export default EventsCalendarPage;
